module.exports = __webpack_public_path__ + "assets/img/router_redirect.e4057620.jpg";